var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.panel.panel_widget_id === 2
        ? _c("notification-widget", { attrs: { isCombo: "true" } })
        : _vm._e(),
      _vm.panel.panel_widget_id === 3
        ? _c("upcoming-widget", {
            attrs: { isCombo: "true", permissions: _vm.permissions },
          })
        : _vm._e(),
      _vm.panel.panel_widget_id === 4 ? _c("marketplace-widget") : _vm._e(),
      [5, 6, 7].includes(_vm.panel.panel_widget_id)
        ? _c("dashboard-trackplus-cards", {
            attrs: { name: _vm.name, panel: _vm.panel, isCombo: "true" },
          })
        : _vm._e(),
      _vm.panel.panel_widget_id === 8
        ? _c("expirtypending-component")
        : _vm._e(),
      _vm.sbObj
        ? [
            _vm.panel.panel_widget_id === 10
              ? _c("due-date-widget", {
                  attrs: { isCombo: "true", sbData: _vm.sbObj },
                })
              : _vm._e(),
            _vm.panel.panel_widget_id === 11
              ? _c("action-tracker", {
                  attrs: { isCombo: "true", sbData: _vm.sbObj },
                })
              : _vm._e(),
            _vm.panel.panel_widget_id === 12
              ? _c("project-status", {
                  attrs: {
                    Initialtitle: "true",
                    isCombo: "true",
                    sbData: _vm.sbObj,
                  },
                })
              : _vm._e(),
            _vm.panel.panel_widget_id === 13
              ? _c("project-type", {
                  attrs: {
                    Initialtitle: "true",
                    type: _vm.type,
                    sbData: _vm.sbObj,
                  },
                })
              : _vm._e(),
            _vm.panel.panel_widget_id === 14
              ? _c("action-due-widgets", { attrs: { sbData: _vm.sbObj } })
              : _vm._e(),
            _vm.panel.panel_widget_id === 15
              ? _c("project-type-status", { attrs: { sbData: _vm.sbObj } })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.sxObj
        ? [
            _vm.panel.panel_widget_id === 18
              ? _c("due-date-widget", {
                  attrs: { isCombo: "true", sbData: _vm.sxObj, isSX: true },
                })
              : _vm._e(),
            _vm.panel.panel_widget_id === 17
              ? _c("project-status", {
                  attrs: {
                    Initialtitle: "true",
                    isCombo: "true",
                    sbData: _vm.sxObj,
                    isSX: true,
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }